<div class="pageNotFound flex flex-col justify-center items-center space-y-3  "
>
  <app-image
    [loaderTheme]="{
             'height': '100%',
             'width': '100%'
            }"
    [url]="'/assets/images/png/pageNotFound.png'"
    class="image-container"
  ></app-image>
  <div class="text"> OOPS! Report Already Downloaded...</div>
  <div class="text-message text-cool-grey">
    The report you are attempting to download has already been downloaded. Please return to the Dashboard and generate a new report.
  </div>
  <app-primary-button
    class="back-button"
    type="small"
    (handleClick)="homepage()"
  >
    Go to Dashboard
  </app-primary-button>
</div>
